import { createAction, props } from "@ngrx/store";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { TransactionType } from "../../shared/types/Transaction";
import { ServiceError } from "../models/shared/ServiceError";
import { StandingAuthorizationsRequest } from "../models/Standing-Authorizations";

export const loadSloas = createAction(
    '[Create Request Page/API] SLOAs Requested / Calling Standing Authorizations',
    props<StandingAuthorizationsRequest>()
);

export const loadSloasSuccess = createAction(
    '[Create Request Page/API] SLOAs Loaded Successfully',
    props<{ instructions: StandingInstruction[], transactionType: TransactionType }>()
)

export const loadSloasFailure = createAction(
    '[Create Request Page/API] SLOAs NOT Loaded',
    props<ServiceError>()
)
